module.exports = __webpack_public_path__ + "media/images/country_flags/kw-8d37c38b383f62811c5c8756f9b7b3d4.png";